import RequestAPI from '@/apis/request';
import PackageAPI from '@/apis/package';
import registersService from '@/apis/registers/registersAPI';
import LicenseTicketApi from '@/apis/tickets';
import PartnerApi from '@/apis/partner';
import AccountApi from '@/apis/accounts/accountAPI'

class MiddleWare {
  /**
   * validate trước khi vào trang tạo request
   * hvmanh 27.9.2023
   * @param {*} to
   * @param {*} from
   * @param {*} next
   */
  async validIdMiddleWare(to, from, next) {
    try {
      const id = to.params.id;
      to.meta.roles = true; // role o day check partner
      const data = await RequestAPI.getDetailRequest(id);
      to.meta.data = data.Data;
      // lấy thông tin các gói p
      const packageResult = await PackageAPI.getListPackage();
      to.meta.packages = packageResult?.Data?.Data?.map((item) => {
        return {
          PackID: item.package_id,
          ProductPackCode: item.package_code,
          PackName: item.package_name,
          PricePerMonth: item.price_per_month,
          PricePerYear: item.price_per_year,
          FeeInitial: item.fee_initial,
          ExtraPos: item.extra_pos,
          ExtraTablet: item.extra_tablet,
          NumberOfPOS: item.number_of_pos,
          NumberOfTablet: item.number_of_tablet,
          NumberOfHandheld: item.number_of_handheld,
          National: item.national,
          ExtraKiosk: item.extra_kiosk
        };
      });

      if (data?.Data?.company_code) {
        // lay thong tin share_rate theo doi tac
        let partner = await PartnerApi.getListPartnerPaging({
          skip: 0,
          take: -1,
          sort: '',
          filter: JSON.stringify([
            {
              Field: 'partner_name',
              Operator: '=',
              Value: data?.Data?.religion,
            },
          ]),
          emptyFilter: '',
          columns: 'purchase_new_rate',
        });

        if (partner?.Data && partner?.Data?.Data && partner?.Data?.Data[0]) {
          // to.meta.data.share_rate = partner?.Data?.Data[0].share_rate || 0;
          // to.meta.data.partner_id = partner?.Data?.Data[0].partner_id;
        }

        // lấy thông tin thiết bị
        let result = await RequestAPI.getDevicesOfDomain(
          data?.Data?.company_code,
          data?.Data?.package_upgrade_key
        );

        to.meta.data.number_pos_display = result?.Data?.number_pos || 0;
        to.meta.data.number_tablet_display = result?.Data?.number_tablet || 0;
        to.meta.data.number_kiosk_display = result?.Data?.number_kiosk || 0;

        // lấy thông tin request gần nhất để thực hiện lấy exchange_rate
        let res = await RequestAPI.nearestRequest();
        to.meta.data.exchange_rate = res?.Data?.exchange_rate;
        to.meta.data.promotion = res?.Data?.promotion;
        if (data?.Data?.package_id == 1 && data?.Data?.ticket_id > 0) {
          let resTicket = await LicenseTicketApi.getDetailTicket(
            data?.Data?.ticket_id
          );

          to.meta.data.agent_number_pos = resTicket?.Data?.number_pos;
          to.meta.data.agent_number_tablet = resTicket?.Data?.number_tablet;
          to.meta.data.agent_note = resTicket?.Data?.note;
          to.meta.data.ticket_package_id = resTicket?.Data?.package_id;
        }
        next();
      } else {
        next('/notfound');
      }
    } catch {
      next('/500');
    }
  }

  async validIdMiddleWareEditPage(to, from, next) {
    try {
      const id = to.params.id;
      to.meta.roles = true; // role o day check partner
      const data = await RequestAPI.getDetailRequest(id);
      to.meta.data = data.Data;
      // lưu tên page trước đó
      to.meta.data.beforeName = from.name;
     
      if(data.Data.modified_employee_id) {
        let resEmployee =  await AccountApi.getAccountPagging({
          skip: 0,
          take: 1,
          sort: '',
          filter: JSON.stringify([
            {
              Field: 'employee_id',
              Operator: '=',
              Value: data.Data.modified_employee_id,
            },
          ]),
          emptyFilter: '',
          columns: 'employee_id',
        });

        if(!resEmployee.Data?.Data?.length){
          to.meta.data.modified_by = '';
        }
      }else {
        to.meta.data.modified_by = ""
      }

      //lấy thông tin các gói
      const packageResult = await PackageAPI.getListPackage();
      to.meta.packages = packageResult?.Data?.Data?.map((item) => {
        return {
          PackID: item.package_id,
          ProductPackCode: item.package_code,
          PackName: item.package_name,
          PricePerMonth: item.price_per_month,
          PricePerYear: item.price_per_year,
          FeeInitial: item.fee_initial,
          ExtraPos: item.extra_pos,
          ExtraTablet: item.extra_tablet,
          NumberOfPOS: item.number_of_pos,
          NumberOfTablet: item.number_of_tablet,
          NumberOfHandheld: item.number_of_handheld,
          National: item.national,
          ExtraKiosk: item.extra_kiosk
        };
      });

      if (data?.Data?.company_code) {   
        // lay thong tin cua license hien thi cho phan license info
        let license = await RequestAPI.getDetailRequestCompanyCode(
          data?.Data?.company_code
        );
        to.meta.licenseInfo = license?.Data && license?.Data;
        // lấy số lượng thiết bị hiển thị
        let result = await RequestAPI.getDevicesOfDomain(
          data?.Data?.company_code,
          data?.Data?.package_upgrade_key
        );
        to.meta.data.number_pos_display = result?.Data?.number_pos || 0;
        to.meta.data.number_tablet_display = result?.Data?.number_tablet || 0;
        to.meta.data.number_kiosk_display = result?.Data?.number_kiosk || 0;
        next();
      } else {
        next('/notfound');
      }
    } catch (ex) {
      next('/500');
    }
  }

  async CheckActiveLink(to, from, next) {
    const companycode = to.params.companycode;
    const activeLink = `${window.origin}${to.fullPath}`;

    const result = await registersService.checkActiveLink({
      companyCode: companycode,
      activeLink: activeLink,
    });
    const data = result.Data;
    if (data) {
      next();
    } else {
      next('/notfound');
    }
  }
}

export default new MiddleWare();
